import apiService from "./apiService";
import AppConstants from "../appConstants";

class GeolocationService {
    getAllGeolocation(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_GEOLOCATION, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    importIpv4Database(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_IMPORT_IPV4_GEOLOCATION_DATABASE, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    importIpv6Database(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_IMPORT_IPV6_GEOLOCATION_DATABASE, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    importAsnDatabase(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_IMPORT_ASN_GEOLOCATION_DATABASE, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getImportStatus(jobId) {
        const params = new URLSearchParams();
        if (jobId) params.append('jobId', jobId);
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_GEOLOCATION_IMPORT_STATUS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new GeolocationService();
